import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-changereasons-edit-modal',
  templateUrl: './changereasons-edit-modal.component.html',
  styleUrls: ['./changereasons-edit-modal.component.css']
})
export class ChangereasonsEditModalComponent implements OnInit {
  @Input() changeReasons: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSaveChangeReasons(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}
